import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { selectIsEmbeddedMessagingCoreFeatureFlagOn } from 'core/userContext';
import { colors, spacing } from 'ui/theme';
import { Placement } from 'modules/campaigns/lib/components/Placement';

const Wrapper = styled.div`
  background: ${colors.grey1};
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  padding: ${spacing.base};
`;

// const StyledLabel = styled(Label)`
//   margin-bottom: ${spacing.half};
// `;

export const EmbeddedMessageFields = () => {
  const isEmbeddedMessagingEnabled = useSelector(selectIsEmbeddedMessagingCoreFeatureFlagOn);

  return (
    <>
      {/* <StyledLabel>Destination</StyledLabel> */}
      {isEmbeddedMessagingEnabled && (
        <Wrapper>
          {/* <Destination /> */}
          <Placement />
        </Wrapper>
      )}
    </>
  );
};
